import CurrencyHelper from './CurrencyHelper';

/**
 * @typedef {{
 *   name: string,
 *   price: number,
 *   priceCurrency: string
 * }} Offer
 */

/**
 * @typedef {{
 *   offers: Offer[],
 *   priceCurrency: string,
 *   opportunityPrice: string
 * }} PriceList
 */

class PriceHelper {
  /**
   * @param {Object} aggregateOffer
   * @param {string} provider
   * @param {string | null} sessionName
   * @returns {PriceList}
   */
  static getPricesList(aggregateOffer, provider, sessionName = null) {
    let offers = [];
    let opportunityPrice;
    let priceCurrency;
    if (aggregateOffer) {
      const isLedClimbingSession = provider === 'led' && sessionName === 'Climbing Sessions';
      if (isLedClimbingSession) {
        offers = [{ name: 'Ages 4+', ...aggregateOffer.publicAdult }];
      } else {
        offers = [
          { name: 'Public Adult', ...aggregateOffer.publicAdult },
          { name: 'Public Junior', ...aggregateOffer.publicJunior },
        ];
      }
      if (aggregateOffer.publicAdult) {
        opportunityPrice = aggregateOffer.publicAdult.price;
        priceCurrency = aggregateOffer.publicAdult.priceCurrency;
      } else if (aggregateOffer.publicJunior) {
        opportunityPrice = aggregateOffer.publicJunior.price;
        priceCurrency = aggregateOffer.publicJunior.priceCurrency;
      }
      if (typeof opportunityPrice === 'number') {
        opportunityPrice = CurrencyHelper.format('en-GB', priceCurrency, opportunityPrice);
      }
    }
    return { offers, priceCurrency, opportunityPrice };
  }
}

export default PriceHelper;
